import React from 'react';
import BounceLoader from '../components/ui/Loaders/BounceLoader';

export const LoaderPage = () => {
  return (
    <div className="loading-container fixed z-[1600] flex flex-col justify-center items-center h-full w-full bg-[#f1f1f180] backdrop-blur-[1px]">
      <BounceLoader loading={true} size={60} />
      <p className="mt-6 text-lg">One Moment Please...</p>
    </div>
  );
};
